import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

/**
 * @description
 * Guard to redirect from old 'quality' routes to new 'water-quality-iq' routes.
 * replaces 'quality' with 'water-quality-iq' in the URL and navigates to the new route.
 * If the URL does not start with 'quality', navigation is allowed to proceed.
 * 
 * @returns
 * returns false if a redirection occurs, true otherwise.
 */
@Injectable({
    providedIn: 'root'
})
export class QualityRedirectGuard  {
    public constructor(private router: Router) { }

    public canActivate(route: ActivatedRouteSnapshot): boolean {
        const url = route.url.map(segment => segment.path).join('/');
        if (url.startsWith('quality')) {
            const newUrl = url.replace('quality', 'water-quality-iq');
            void this.router.navigateByUrl(`/${newUrl}`, { replaceUrl: true });
            return false;
        }
        // Allow navigation otherwise
        return true;
    }
}
